'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldSetLocaleFromSettings = exports.shouldSetLocaleFromProps = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getActiveLocale = (0, _get2.default)('activeLocale');
var getLocaleFromProps = (0, _get2.default)('localeFromProps');

var shouldSetLocaleFromProps = exports.shouldSetLocaleFromProps = (0, _reselect.createSelector)([getLocaleFromProps, getActiveLocale], function (localeFromProps, activeLocale) {
  return Boolean(localeFromProps) && localeFromProps !== activeLocale;
});

var shouldSetLocaleFromSettings = exports.shouldSetLocaleFromSettings = (0, _reselect.createSelector)([getLocaleFromProps, _BookInfoSelectors.getLocaleFromSettings, getActiveLocale], function (localeFromProps, localeFromSettings, activeLocale) {
  return !localeFromProps && Boolean(localeFromSettings) && localeFromSettings !== activeLocale;
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/LocalizationSelectors.js
// module id = 492
// module chunks = 0